import { PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { put, call, takeEvery } from 'typed-redux-saga';
import CustomerTransferGateway from '~apis/customerTransfer';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TCreateConversionDraftsAPIResponse, TCreateGoldConversionReduxParams } from '~types/feat/gold';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchCreateCustomerTransferDrafts(api: CustomerTransferGateway): SagaWatcherReturnType {
    yield takeEvery('customerTransfer/customerTransferCreateCustomerTransferDraftAttempt', handleCreateCustomerTransferDrafts, api);
}

function* handleCreateCustomerTransferDrafts(api: CustomerTransferGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const response = yield* call([api, api.createCustomerTransferDrafts], {
        authToken,
    });

    if (response.status === GatewayResponseStatus.Error) {
        toast.error(response.message || ErrorMessages.GoldCreateTransactionError);
        yield put(combinedActions.customerTransferCreateCustomerTransferDraftFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.customerTransferCreateCustomerTransferDraftSuccess(response.data));
    }
}
